import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 3rem;
  padding-bottom: 10rem;
  background-color: ${({ theme }) => theme.colors.light[50]};

  margin: 0 auto;
  @media (${({ theme }) => theme.medias.desktop}) {
    max-width: 100rem;
    padding: 3rem 10rem;
    padding-bottom: 10rem;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 0;
  gap: 2rem;
  width: 100%;
  max-width: 70rem;

  & > h1 {
    font-size: 3rem;
    text-align: center;
    font-family: "Merriweather Regular";
    & > span {
      color: #f76c6f;
    }
  }
  & > p {
    font-size: 1.6rem;
    text-align: center;
    font-family: "Montserrat Regular";
    & > span {
      font-family: "Montserrat Medium";
      color: #f76c6f;
    }
  }
`;

export const TargetContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 0;
  width: 100%;
  max-width: 50rem;
  & > h2 {
    font-size: 2.4rem;
    text-align: center;
    font-family: "Merriweather Regular";
    margin-bottom: 2rem;
    & > span {
      color: #f76c6f;
    }
  }
  & > h3 {
    width: 100%;
    text-align: left;
    font-size: 1.8rem;
    text-transform: uppercase;
    font-family: "Montserrat Regular";
    margin-bottom: 1rem;
  }
  & > p {
    width: 100%;
    text-align: left;
    font-size: 1.8rem;
    font-family: "Montserrat Medium";
    margin-bottom: 3rem;
  }
  & > ul {
    width: 100%;
    text-align: left;
    margin-left: 5rem;
    & > li {
      font-size: 1.8rem;
    }
  }
`;

export const ListBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 3rem 0;
  padding: 2rem 0;
  width: 100%;
  max-width: 50rem;
  border: 1px solid #f76c6f;
  border-radius: 2rem;
  padding: 2rem;
  & > h2 {
    font-size: 2.4rem;
    text-align: center;
    font-family: "Merriweather Regular";
    margin-bottom: 2rem;
    & > span {
      color: #f76c6f;
    }
  }
  & > ul {
    list-style: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    width: 100%;
    & > li {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      width: 100%;
      gap: 2rem;
      & > svg {
        background-color: #f76c6f;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        padding: 2px;
        width: 3rem;
        height: 3rem;
        min-width: 3rem;
        min-height: 3rem;
      }

      & > p {
        font-size: 1.8rem;
        text-align: left;
        font-family: "Montserrat Regular";
        & > span {
          font-family: "Montserrat Medium";
          color: #f76c6f;
        }
      }
    }
  }
`;
